<template>
    <nav>
        <div class="header">
            <div class="logo">
                <img src="logos/img_logo.png" style="width: 272px; height: 37px;"/>
            </div>
        </div>
        <div style="position: relative;">
            <img :value="this.page" src="logos/texture.jpg" id="title">
            <div :value="this.page" id="text">
                <div v-if="this.page == 'attribute'">
                    研究室マッチング<br>システム
                </div>
                <div v-else>
                    研究室マッチングシステム
                </div>
            </div>
        </div>
    </nav>
</template>
<script>
export default {
    props: ['page'],
}
</script>
<style>
.header {
    min-height: 3.25rem;
    width: 100vw;
    height: auto;
    padding: 0.5rem;
    background-image: linear-gradient(120deg, rgba(255,255,255,0) 80%, #faee00 80%);
}
.logo {
    width: 288px;
    height: 96px;
    margin-left: 12px;
    align-items: center;
    display: flex;
}
#text {
    position: absolute;
    top: 35%;
    left: 50%;
    width: 100%;
    transform: translate(-50%, -50%);
    text-align: center;
    color: white; /* テキストの色を適切に設定 */
    font-size: 5.33vw;
    text-shadow: 1px 1px 2px black;
}
#text[value="attribute"] {
    text-align: center;
}
#title {
    width: 100vw;
    height: 11.11vw;
    color: white;
    margin-bottom: 16px;
}
#title[value="attribute"] {
    height: 22.22vw;
}
@media (min-width: 450px) {
    #text {
        top: 40%;
    }
}
@media (min-width: 960px) {
    .header {
        min-height: 3.25rem;
        width: 100vw;
        height: auto;
        padding: 0.5rem;
        background-image: linear-gradient(120deg, rgba(255,255,255,0) 40%, #faee00 40%);
    }
    .logo {
        margin-left: 64px;
    }
    #text {
        font-size: 36px;
        text-align: left;
        margin-left: 64px;
    }
    #text[value="attribute"] {
        font-size: 48px;
        margin-left: 0;
    }
    #title {
        height: 110px;
    }
    #title[value="attribute"] {
        height: 200px;

    }
}

</style>